module.exports = __webpack_public_path__ + "media/images/logomin-fe4a30d292efbaaca8fcf34aa73933ce.png";